import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditPostModal = ({ show, handleClose, post, onSave }) => {
    const [text, setText] = useState(post.text || '');
    const [tags, setTags] = useState(() => {
        try {
            const parsed = JSON.parse(post.tag);
            return Array.isArray(parsed) ? parsed.join(' ') : '';
        } catch (e) {
            return '';
        }
    });

    const handleSubmit = async () => {
        const tagsArray = tags.trim().split(' ').filter(Boolean);

        const res = await fetch("https://api.fantasyworldtrpg.cz/echo/edit_post.php", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                postId: post.id,
                userId: localStorage.getItem("echo_user"),
                text,
                tags: tagsArray
            })
        });

        const data = await res.json();
        if (data.status === "success") {
            onSave();
            handleClose();
        } else {
            alert("Nepodařilo se uložit úpravu.");
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header className="bg-light" closeButton>
                <Modal.Title>📝 Úprava příspěvku</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <Form.Group className="mb-3">
                    <Form.Label>Text</Form.Label>
                    <Form.Control as="textarea" rows={3} value={text} onChange={(e) => setText(e.target.value)} />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Hashtagy (oddělené mezerou)</Form.Label>
                    <Form.Control value={tags} onChange={(e) => setTags(e.target.value)} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={handleClose}>Zrušit</Button>
                <Button variant="danger" onClick={handleSubmit}>Uložit změny</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPostModal;
